/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { Grid } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import updateState from '../../actions/updateState';
import translate from '../../actions/translate';

export default function AlertDialog({ setLoading }) {
  const [open, setOpen] = React.useState(false);
  const [promo, setPromo] = React.useState('');
  const env = process.env.REACT_APP_ENV;
  const dispatch = useDispatch();
  const baseURL = useSelector((state) => state.formState.baseURL);

  const handlePromo = () => {
    dispatch(
      updateState({
        alreadyWorkWithUs: false,
      })
    );
    dispatch(updateState({ failedRestaurantSearch: false }));
    const getRestaurant = async () => {
      setLoading(true);
      const config = {
        headers: {
          'Content-Type': 'application/json',
        },
      };
      const body = {
        method: 'get',
        resource: 'restaurant',
        query: {
          'selfSignup.code': promo,
        },
        payload: {
          name: 1,
          alias: 1,
          googleListing: 1,
          selfSignup: 1,
          disabled: 1,
          'menus.id': 1,
        },
      };

      try {
        const res = await axios.post(
          `${baseURL}/smart-restaurant/api`,
          body,
          config
        );

        // const event = await axios.get(
        //   'https://67dqylz39g.execute-api.us-east-2.amazonaws.com/dev/generic',
        //   {
        //     resource: 'analytics-event',
        //     query: { src: 'self-signup' },
        //     limit: 100000,
        //   },
        //   config
        // );

        setLoading(false);
        dispatch(updateState({ failedRestaurantSearch: false }));
        dispatch(updateState({ failedPromoCode: false }));
        console.log('RES OBJ ', res);
        console.log('RESPONSE OBJECT ', res.data[0].disabled.toString());
        if (
          res.data[0].disabled.toString() === 'false' ||
          (res.data[0].selfSignup && res.data[0].selfSignup.acknowledgedAt)
        ) {
          console.log('DISABLED VAL ', res.data[0].disabled);
          dispatch(updateState({ alreadyWorkWithUs: true }));
        }
        dispatch(updateState({ Signup_type: 'promo' }));
        dispatch(updateState({ version: res.data[0].version }));
        dispatch(updateState({ Restaurant_alias: res.data[0].alias }));
        dispatch(updateState({ Restaurant_found: true }));
        dispatch(
          updateState({
            Restaurant_address: res.data[0].googleListing.address,
          })
        );
        dispatch(updateState({ showRestaurantSearch: false }));

        if (res.data[0].menus) {
          dispatch(updateState({ menu_id: res.data[0].menus[0].id }));
        }
        dispatch(updateState({ Restaurant_found: res.data[0].name }));
        // eslint-disable-next-line no-param-reassign, no-underscore-dangle
        // eslint-disable-next-line no-param-reassign, no-underscore-dangle
        dispatch(updateState({ Restaurant_id: res.data[0]._id }));
        dispatch(
          updateState({ Google_phone: res.data[0].googleListing.phone })
        );
        dispatch(updateState({ Signup_type: 'Promo' }));
      } catch (e) {
        setLoading(false);
        dispatch(
          updateState({
            alreadyWorkWithUs: false,
          })
        );
        dispatch(updateState({ failedPromoCode: true }));
        console.log('request failed');
      }
    };
    if (promo) {
      getRestaurant();
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    dispatch(updateState({ Signup_type: 'Promo' }));
    setOpen(false);
  };

  return (
    <>
      <Button
        onKeyDown={handleClickOpen}
        role="presentation"
        onClick={handleClickOpen}
      >
        <u>{translate('Have Promo?')}</u>
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container>
          <Grid container item justify="flex-start">
            <IconButton
              variant="outlined"
              onClick={() => {
                handleClose();
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>

        <DialogTitle id="alert-dialog-title">
          {translate('Enter Promo')}{' '}
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TextField
              onChange={(e) => setPromo(e.target.value)}
              id="standard-basic"
              label="Promo"
            />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
              handlePromo();
            }}
            color="primary"
            autoFocus
          >
            {translate('Enter')}
          </Button>
        </DialogActions>
      </Dialog>{' '}
    </>
  );
}
